import React from 'react'

import GlobalStyle from '../components/GlobalStyle'

import 'sanitize.css'
import '../styles/fonts.css'

const App = ({
  Component,
  pageProps,
  err
}) => {
  return (
    <>
      <GlobalStyle />
      <Component
        err={err}
        {...pageProps}
      />
    </>
  )
}

export default App
